// src/hooks/products/useGetProgramHotelConfig.js
import { useQuery } from "@tanstack/react-query";
import { getProgramHotelConfig } from "../../api/apiProducts";
import i18next from "i18next";

/**
 * Hook to get lightweight hotel product configuration for program form
 */
const useGetProgramHotelConfig = () => {
    const { data, error, isLoading, isFetching, refetch } = useQuery({
        queryKey: ["program-hotel-config", i18next.language],
        queryFn: getProgramHotelConfig,
        staleTime: 1000 * 60 * 15, // 15 minutes cache
        cacheTime: 1000 * 60 * 30,
    });

    const hotelProduct = data?.data || data || null;

    return {
        hotelProduct,
        error,
        isLoading,
        isFetching,
        refetch,
    };
};

export default useGetProgramHotelConfig;
